/**
 * withShortcuts Plugin
 * Enables Markdown-style shortcuts for auto-formatting
 */
import { Editor, Range, Element as SlateElement, Transforms } from 'slate';
import { SHORTCUTS } from '../constants';
import { toggleBlock } from '../editor.utils';

const withShortcuts = (editor: Editor) => {
  const { insertText } = editor;

  editor.insertText = (text) => {
    const { selection } = editor;

    if (text === ' ' && selection && Range.isCollapsed(selection)) {
      const { anchor } = selection;
      const block = Editor.above(editor, {
        match: (n) => SlateElement.isElement(n) && Editor.isBlock(editor, n),
      });

      if (block && block[0] && 'type' in block[0] && block[0].type === 'paragraph') {
        const [, blockPath] = block;
        const start = Editor.start(editor, blockPath);
        const range = { anchor, focus: start };
        const beforeText = Editor.string(editor, range);

        // Check for numbered list (e.g., "1.", "2.")
        if (/^\d+\.$/.test(beforeText)) {
          Transforms.select(editor, range);
          Transforms.delete(editor);
          toggleBlock(editor, 'numbered-list');
          return;
        }

        // Check for other shortcuts
        const type = SHORTCUTS[beforeText as keyof typeof SHORTCUTS];
        if (type) {
          Transforms.select(editor, range);
          Transforms.delete(editor);
          toggleBlock(editor, type);
          return;
        }
      }
    }

    insertText(text);
  };

  return editor;
};

export default withShortcuts;
